import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PhotosphereList } from "../../entities/photospherelist.model";
import { MarkerType } from "../../../crossconcern/types/marker.type";
import { MarkerModel } from "../../entities/marker.model";
import { MediaList } from "../../entities/medialist.model";
import { PhotosphereType } from "../../../crossconcern/types/photosphere.type";
import { PhotosphereModel } from "../../entities/photosphere.model";

@Injectable()
export abstract class PhotosphereRepositoryInterface {
    public abstract getPhotospheres(
        pageSize: number,
        page: number,
        nurseryUUID?: string,
        withNursery?: boolean,
        withMedia?: boolean)
    : Observable<PhotosphereList>;

    public abstract getPhotosphereMedia(uuid: string): Observable<MediaList>;
    public abstract updatePhotosphere(uuid: string, photosphere: PhotosphereType): Observable<PhotosphereModel>;
    public abstract associatePhotosphereProduct(photosphereUuid: string, productUuid: string): Observable<PhotosphereModel>;
    public abstract disassociatePhotosphereProducts(photosphereUuid: string): Observable<PhotosphereModel>;
    public abstract deletePhotosphere(uuid: string): Observable<{}>;
    public abstract getMarker(markerUUID: string): Observable<MarkerModel>
    public abstract addMarker(marker: MarkerType): Observable<MarkerModel>;
    public abstract updateMarker(markerUUID: string, marker: MarkerType): Observable<MarkerModel>;
    public abstract deleteMarker(markerUUID: string): Observable<{}>;
}